import {
    CURRENT_PAGE_TITLE,
} from "redux/constants";

export function updatePageTitle(pageTitle) {
    return {
        type: CURRENT_PAGE_TITLE,
        payload: pageTitle,
    };
}